export function AiRobotIcon(props: { size?: number; className?: string }): JSX.Element {
  const size = props.size ?? 20;
  return (
    <svg
      className={props.className}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M12 3v2M9.5 3h5" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
      <rect x="4" y="6" width="16" height="13" rx="4" stroke="currentColor" strokeWidth="1.8" />
      <path d="M4 11H2.5v4H4M20 11h1.5v4H20" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
      <circle cx="9" cy="12" r="1.25" fill="currentColor" />
      <circle cx="15" cy="12" r="1.25" fill="currentColor" />
      <path d="M9 16h6" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
    </svg>
  );
}
